// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import veeEn from 'vee-validate/dist/locale/en';
import veeFr from 'vee-validate/dist/locale/fr';
import VueAffix from 'vue-affix';
import Vuelidate from 'vuelidate';

import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import 'quill/dist/quill.snow.css';


import * as globalMixins from './mixins';

Vue.mixin(globalMixins);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAffix);
Vue.use(Vuelidate);

const veeConfig = {
  i18n, // the vue-i18n plugin instance,
  dictionary: {
    en: veeEn,
    fr: veeFr,
  },
};

Vue.use(VeeValidate, veeConfig);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js